export const incomeCatSelector = (state) => state.statistics.income;
export const expenseCatSelector = (state) => state.statistics.expense;
export const totalIncomeSelector = (state) => state.statistics.totalIncome;
export const totalExpenseSelector = (state) => state.statistics.totalExpense;
export const balanceSelector = (state) => state.statistics.balance;
